function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1440.33,
  height: 260,
  fill: "#1D50A4"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_29_4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 260.269,
  fill: "#184CC0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M858.418 242.982H268.122H170L278.038 195.28C343.801 131.18 339.625 40.2485 320.314 0H1027C1008.73 32.2982 998.816 73.0436 994.119 118.758L858.418 242.982Z",
  fill: "#3A6EE9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M777 242.982V98.9214L627 242.982H777Z",
  fill: "#184CC0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627 242.982V98.9214L477 242.982H627Z",
  fill: "#245CD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M777 97.961V-46.0993L627 97.961H777Z",
  fill: "#245CD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627 97.961V-46.0993L477 97.961H627Z",
  fill: "#184CC0"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 221.25,
  ry: 240.776,
  transform: "matrix(0.968447 0.249219 -0.268734 0.963214 1246.97 28.7109)",
  fill: "#184CC0",
  stroke: "#245CD9",
  strokeWidth: 100
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 169.839,
  cy: 67.2281,
  rx: 185.839,
  ry: 175.754,
  fill: "#245CD9"
}));

function SvgApplicationHeaderLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 260,
    viewBox: "0 0 1440 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 260
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationHeaderLarge);
export default __webpack_public_path__ + "static/media/application-header-large.810ce4cb.svg";
export { ForwardRef as ReactComponent };